export {
  whyZapierLink,
  exploreLink,
  resourcesLink,
  teamsLink,
  pricingLink,
  dashboardLink,
  zapsLink,
  myAppsLink,
  historyLink,
  helpLink,
  usageLink,
  moveZapsLink,
  settingsLink,
  logOutLink,
  UniversalSidebarLinks,
  UniversalTopbarLinks,
  AccountsMenuLinks,
} from './links';
export type {
  UniversalNavLinkType
} from './links';

// Account action paths
export const signupPath = '/sign-up/';
export const loginPath = '/app/login';

// Utility constants
export const skipLinkHref = '#mainContent';
export const UNIVERSAL_TOPBAR_HEIGHT = 70;
export const UNIVERSAL_TOPBAR_CONDENSED_HEIGHT = 60;

// Events related to the App Search Bar
export const searchClosed = 'Zapbook: App Header search closed';
export const searchOpened = 'Zapbook: App Header search opened';
export const searchHasResults = 'Zapbook: Results in search';
export const searchHasNoResults = 'Zapbook: No results in search';
export const searchResultClick = 'Zapbook: App header search result selected';
